import { Observable } from 'rxjs/Observable';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { Response } from '@angular/http';
import { HttpResponse } from '@angular/common/http';

export class ResponseUtil {

  static unwrapErrorMessage(response: Response): ErrorObservable {
    let customMessage = '';
    if (response.json() && response.json().error) {
      customMessage = response.json().error;
    }
    const errorMessage = `Response with status ${ response.status }: ${ customMessage }`;
    return Observable.throw(errorMessage);
  }

  static getFileNameFromHttpResponse(httpResponse: HttpResponse<Blob>) {
    let fileName = undefined;

    let contentDispositionHeader = httpResponse.headers.get('Content-Disposition');
    if (contentDispositionHeader) {
      let result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
      fileName = result.replace(/"/g, '');
    }

    return fileName;
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/utils/response-util.ts